import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import Text from '../../form/form-text'
import DateTimePicker from '../../form/form-date-time-picker'

import '../module.styl'
class ModuleSchedulingTitle  extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: props.data,
            disabled: this.props.disabled
        }
    }

    onChange() {
        this.props.onChange(this.state.data)
    }

    render() {
        return <div className="module moduleSchedulingTitle">
            <DateTimePicker disabled={true} date={new Date(this.state.data.startDate)} dateFormat={'HH:mm - DD MMMM YYYY'} />
            <Text disabled={true} value={this.state.data.name} />
        </div>;
    }
}

ModuleSchedulingTitle .propTypes = {
    onChange: PropTypes.func.isRequired,
    data: PropTypes.shape({
        name: PropTypes.string,
        startDate: PropTypes.string,
        visibility: PropTypes.bool
    })
}

export default injectIntl(ModuleSchedulingTitle );
